import { useEffect, useMemo, useState } from 'react';
import { PortfolioBalanceSheetStatistics } from '../../../components/PortfolioBalanceSheetStatistics';
import { buildBoxAdjustedComposition } from '../../../utils/boxAdjustedComposition';
import { Container, RowDiv, BannerContent, Header } from './homeStyles';
import { useNewTheme } from '../../../hooks/useNewTheme';
import { useActives } from '../../../hooks/useActives';
import { useTitleAndUser } from '../../../hooks/userTitle';
import { DataHomeResume } from './components/DataHomeResume';
import { TutorialIbox } from './components/TutorialIbox';
import { NewsComponent } from './components/NewsComponent';
import { Heading } from '../../../components/DefaultStylesTypography';
import { CongratulationsCreatingAccount } from './components/CongratulationsCreatingAccount';
import './customToastStyles.css';
import { ModalDesigner } from '../../../components/ModalDesigner';
import { string } from 'zod';
import { expireMensages } from '../../../social/constants';
import axios from 'axios';
import { userRoutes, walletRoutes } from '../../../utils/RoutesApi';
import moment from 'moment';
import { CarouselDashInfos } from './components/CarouselDashInfos';
import { useStrategy } from '../../pages/Wallet/hooks/StrategyHooks';
import axiosService from '../../../utils/axios';
import { baseURL } from '../../../utils/baseURL';
import { LoadingBanner } from './LoadingCard';
import BFBanner from '../../../assets/business/independencia2026.jpeg';
import iBest from '../../../assets/business/bannercorrigidoibestluciano.jpeg';
import { HeaderContainer } from '../../../Header';
import { useHistory } from 'react-router-dom';

const Home = () => {
  const { user } = useTitleAndUser();
  // const announcement = localStorage.getItem(process.env.REACT_APP_ANNOUNCEMENT);
  const route = window.location.pathname;
  const updateNewsAtt = localStorage.getItem(process.env.REACT_APP_NEWS);
  const [modalWelcome, setModalWelcome] = useState(
    () => route === '/dashboard/led'
  );
  // const [isPromotion, setIsPromotion] = useState(
  //   () => announcement !== 'close'
  // );
  const [iBestModal, setIBestModal] = useState(false);
  const [isPromotion, setIsPromotion] = useState(false);
  const { setTitle } = useTitleAndUser();
  const { shortSidebar } = useNewTheme();
  const { actives, loadingActive } = useActives();

  // Distribuição da carteira DESCONSIDERANDO a parte alocada em boxes
  // (via box_applied_percentage), usada no gráfico de Análise Geral.
  const boxAdjustedPercentage = useMemo(
    () => buildBoxAdjustedComposition(actives?.positionsAll ?? []),
    [actives]
  );
  const [strategyPercentage, setStrategyPercentage] = useState({});
  const [strategyPercentageLoading, setStrategyPercentageLoading] =
    useState(false);

  const isLead = localStorage.getItem('isLead');
  const isLeadJSON = isLead ? JSON.parse(isLead) : [];
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [plan, setPlan] = useState({});
  
  const [showNews, setShowNews] = useState(false);
  const [maintenanceModal, setMaintenanceModal] = useState(true);


  const checkPlanExpiry = (plan) => {
    try {
      if (plan.currentPeriodEnd) {
        const daysLeft = moment(plan?.currentPeriodEnd).diff(moment(), 'days');

        const messageKey = String(daysLeft);
        const message = expireMensages[messageKey];
        if (message) {
          setModalMessage(message);
          setModalVisible(true);
        }
      }
    } catch (error) {}
  };
  // fazer modal abrir de vez em quando:
  function shouldShowPromotion() {
    const lastShown = localStorage.getItem('promotion_last_shown');
    const today = new Date().toDateString();

    if (lastShown === today) {
      return false; // já mostrou hoje
    }

    return true;
  }




  async function handlePayment() {
    try {
      await axios
        .get(`${process.env.REACT_APP_API_URL}${userRoutes.STATUS_PAYMENT}`)
        .then((response) => {
          setPlan(response.data);
        })
        .catch((err) => {
          //@ts-ignore

          setPlan(null);
        });
    } catch (error) {}
  }

  if (!isLeadJSON.includes(user.email) && route === '/dashboard/led') {
    setTimeout(() => {
      localStorage.setItem(
        'isLead',
        JSON.stringify([...isLeadJSON, user.email])
      );
    }, 5000);
  }

  const getStrategyData = async () => {
    try {
      setStrategyPercentageLoading(true);
      const response = await axios.get(
        `${baseURL}/api${walletRoutes.WALLET_GET_CONFIG_STRATEGY}`
      );
      setStrategyPercentage({
        fii: response?.data?.data?.PorcentagemFII || 0,
        action: response?.data?.data?.PorcentagemAcoes,
        rendaFixa: response?.data?.data?.PorcentagemRendaVariavel,
        stocks: response?.data?.data?.PorcentagemStock || 0,
        etfs: response?.data?.data?.PorcentagemEtf || 0,
        reits: response?.data?.data?.PorcentagemReit || 0,
        crypto: response?.data?.data?.PorcentagemCripto || 0,
      });
      setStrategyPercentageLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlePayment();
    getStrategyData();
  }, []);
  const his = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
    setTitle('Dashboard');
    localStorage.removeItem('news_v_1.0.9');
    localStorage.removeItem('promotion');

    // if (announcement !== 'close') {
    //   localStorage.setItem(process.env.REACT_APP_ANNOUNCEMENT, 'close');
    // }
    if (updateNewsAtt !== 'false') {
      localStorage.setItem(process.env.REACT_APP_NEWS, 'false');
    }

    checkPlanExpiry(plan);
  }, [route, setTitle, updateNewsAtt, user.email, plan]);
  useEffect(() => {
    if (shouldShowPromotion()) {
      setIsPromotion(true);
      setShowNews(true);

      // marca como exibido no dia
      localStorage.setItem('promotion_last_shown', new Date().toDateString());
    }
  }, []);

  useEffect(() => {
    const lastShown = localStorage.getItem('ibest_modal_last_shown');
    const today = new Date().toDateString();

    if (lastShown !== today) {
      setIBestModal(true);
    }
  }, []);


  return (
    <HeaderContainer>
      <Container>
        <div>
          <BannerContent
            src={BFBanner}
            onClick={() => {
              his.push('/pagamentos');
            }}
          />
        </div>
        <div id="card-home">
          <DataHomeResume/>
        </div>
        {loadingActive || strategyPercentageLoading ? (
          <LoadingBanner />
        ) : (
          <RowDiv isShort={shortSidebar}>
            <PortfolioBalanceSheetStatistics
              percentage={boxAdjustedPercentage}
              strategyPercentage={strategyPercentage}
            />
            <CarouselDashInfos />
          </RowDiv>
        )}

        {/* <div className="containerTutorial" style={{ width: '100%' }}>
          <Heading
            as="h3"
            variant="tertiary"
            className="tutorial"
            color="#535862"
          >
            Tutorial Imposto de Renda - iBox6
          </Heading>
          <div style={{ position: 'relative', paddingTop: '46.25%' }}>
            <iframe
              id="panda-2c3830ef-7664-41c1-bca7-f1574e0cccf6"
              src="https://player-vz-447732c4-8c0.tv.pandavideo.com.br/embed/?v=2c3830ef-7664-41c1-bca7-f1574e0cccf6"
              style={{
                border: 'none',
                borderRadius: 16,
                position: 'absolute',
                top: 0,
                left: 0,
              }}
              allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
              allowFullScreen
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div> */}

        <div className="containerTutorial" style={{ width: '100%' }}>
          <Heading
            as="h3"
            variant="tertiary"
            className="tutorial"
            color="#535862"
          >
            Tutorial - Como usar o iBox6
          </Heading>
          <div style={{ position: 'relative', paddingTop: '46.25%' }}>
            <iframe
              id="panda-df4c57bf-9d44-49bd-80dd-cc14c4b91576"
              src="https://player-vz-447732c4-8c0.tv.pandavideo.com.br/embed/?v=df4c57bf-9d44-49bd-80dd-cc14c4b91576"
              style={{
                border: 'none',
                borderRadius: 16,
                position: 'absolute',
                top: 0,
                left: 0,
              }}
              allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
              allowFullScreen
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div>
        {/* <TutorialIbox /> */}
        {/* <ModalDesigner
          isOpen={isPromotion}
          id="congratulations"
          title="📢 Atenção, iBoxer!"
          setState={(newState) => {
            // emptyCacheStorage();
            // window.location.reload();
            localStorage.setItem(process.env.REACT_APP_ANNOUNCEMENT, 'close');
            setIsPromotion(newState);
            // setNewAtt(newState);
          }}
        >
          {showNews && <NewsComponent />} */}

          {/* <NewsComponent /> */}
        {/* </ModalDesigner> */}
        <ModalDesigner
          isOpen={modalWelcome}
          id="congratulations"
          setState={setModalWelcome}
        >
          <CongratulationsCreatingAccount />
        </ModalDesigner>
        <div id="avisoExpira">
          <ModalDesigner
            id="avisoModal"
            className="modal-designer"
            isOpen={modalVisible}
            setState={setModalVisible}
          >
            <h2 id="aviso">📢Sua assinatura está expirando!</h2>
            <h4 id="subtititulo">Olá, iBoxer!</h4>
            <p id="mensagem">{modalMessage}</p>
          </ModalDesigner>
        </div>
        {/* <ModalDesigner
          isOpen={maintenanceModal}
          id="maintenanceModal"
          className="modal-designer"
          setState={setMaintenanceModal}
        >
          <div style={{ textAlign: 'center', padding: '0.5rem' }}>
            <h2 style={{ marginBottom: '1rem' }}>
              🚀 Ativos Internacionais chegaram ao iBox6! 🌎
            </h2>

            <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#374151' }}>
              Mais um grande passo para você acompanhar seu patrimônio sem fronteiras!
            </p>

            <div
              style={{
                margin: '1.5rem 0',
                textAlign: 'left',
                display: 'inline-block',
              }}
            >
              <p>✅ Análise de ativos internacionais já disponível</p>
              <p>✅ Importação manual de ativos internacionais para sua carteira já disponível</p>
            </div>

            <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#374151' }}>
              Agora ficou ainda mais fácil acompanhar seus investimentos globais diretamente no iBox6. 💙
            </p>

            <p
              style={{
                fontSize: '1rem',
                lineHeight: '1.6',
                color: '#b45309',
                fontWeight: 600,
                marginTop: '1rem',
              }}
            >
              ⚠️ Esta é uma novidade recém-lançada e ainda está em fase de evolução.
            </p>

            <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#374151' }}>
              Por isso, alguns ajustes e melhorias poderão acontecer nas próximas atualizações.
            </p>

            <p
              style={{
                fontSize: '1rem',
                fontWeight: 600,
                marginTop: '1rem',
                color: '#1d4ed8',
              }}
            >
              💻 Disponível neste momento apenas na versão web (computador).
            </p>

            <p
              style={{
                fontSize: '1.05rem',
                fontWeight: 700,
                marginTop: '1.5rem',
                color: '#374151',
              }}
            >
              Explore a novidade e seja um dos primeiros a conhecer o futuro do iBox6! 🚀🌍
            </p>
          </div>
        </ModalDesigner> */}
        {/* <ModalDesigner
          isOpen={iBestModal}
          id="iBestModal"
          className="modal-designer"
          setState={(newState) => {
            setIBestModal(newState);

            if (!newState) {
              llocalStorage.setItem(
                'ibest_modal_last_shown',
                new Date().toDateString()
              );
            }
          }}
        >
          <div
            style={{
              textAlign: 'center',
              padding: '0.5rem',
              width: '100%',
              maxWidth: '970px',
            }}
          >
            <a
              href="https://premioibest.vote/349485881"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                localStorage.setItem(
                  'ibest_modal_last_shown',
                  new Date().toDateString()
                );
                setIBestModal(false);
              }}
              style={{
                display: 'block',
                width: '100%',
              }}
            >
              <img
                src={iBest}
                alt="Vote no iBox6 no Prêmio iBest"
                style={{
                  display: 'block',
                  width: '100%',
                  height: 'auto',
                  borderRadius: '12px',
                  cursor: 'pointer',
                }}
              />
            </a>

            <button
              type="button"
              onClick={() => {
                window.open(
                  'https://premioibest.vote/349485881',
                  '_blank',
                  'noopener,noreferrer'
                );

                localStorage.setItem(
                  'ibest_modal_last_shown',
                  new Date().toDateString()
                );
                setIBestModal(false);
              }}
              style={{
                marginTop: '1rem',
                border: 'none',
                borderRadius: '8px',
                padding: '0.75rem 1.5rem',
                background: '#2563eb',
                color: '#ffffff',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Votar no Luciano
            </button>
          </div>
        </ModalDesigner> */}
      </Container>
    </HeaderContainer>
  );
};
export default Home;
